import React, { useState } from 'react';
import axios from 'axios';
import './ChangeDisplayName.css';

const ChangeDisplayName = () => {
  const [fullName, setFullName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Retrieve userId from localStorage (ensure it's stored correctly during login)
  const user = JSON.parse(localStorage.getItem('user'));
  const id = user ? user.id : null; // Use 'userId' if it was saved correctly

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Show loading spinner
    setLoading(true);
    setError('');
    setSuccess('');

    // Create payload to send to backend
    const payload = { fullName };

    // Check if userId is available before making the request
    if (!id) {
      const message = 'User ID is missing! Please log in again.';
      setError(message);
      setLoading(false);
      window.alert(message); // Show alert
      return;
    }

    try {
      // Send PUT request to the backend with the correct userId
      const response = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/user/updateDisplayName/${id}`, payload);

      // On success, show success message
      if (response.status === 200) {
        const message = 'Display name updated successfully!';
        setSuccess(message);
        window.alert(message); // Show alert
      }
    } catch (error) {
      // Handle errors
      const message = 'Error updating display name. Please try again.';
      setError(message);
      window.alert(message); // Show alert
    } finally {
      // Hide loading spinner
      setLoading(false);
    }

    // Clear the input field after submission
    setFullName('');
  };

  return (
    <div className="changeDisplayNameMain">
      <div className="text-center">
        {/* <h4 className="display-title">User Profile Update</h4> */}
      </div>
      <div className="card">
        <div className="card-header">Change Display Name</div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="form-group-cdn">
              <label htmlFor="displayName">New Display Name</label>
              <input
                type="text"
                id="displayName"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                required
              />
            </div>
            <button type="submit" disabled={loading}>
              {loading ? 'Updating...' : 'Submit'}
            </button>
          </form>
          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}
        </div>
      </div>
    </div>

  );
};

export default ChangeDisplayName;
